import { Navigate, Route, Routes } from 'react-router-dom';
import { LabShell } from '@/components/LabShell';
import { BlockIsolatePage } from '@/pages/BlockIsolatePage';
import { CoveragePage } from '@/pages/CoveragePage';
import { GalleryPage } from '@/pages/GalleryPage';
import { GridComparePage } from '@/pages/GridComparePage';
import { BatchParityPage } from '@/pages/BatchParityPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { BootstrapCapturePage } from '@/pages/BootstrapCapturePage';
import { HeroStockReviewPage } from '@/pages/HeroStockReviewPage';
import { PageLabPage } from '@/pages/PageLabPage';
import { TierMatrixPage } from '@/pages/TierMatrixPage';

export function AppRouter() {
  return (
    <Routes>
      <Route element={<LabShell />}>
        <Route index element={<OverviewPage />} />
        <Route path="matrix/block/:componentType" element={<BlockIsolatePage />} />
        <Route path="matrix/grid/:componentType" element={<GridComparePage />} />
        <Route path="matrix/gallery" element={<GalleryPage />} />
        <Route path="matrix/page/:pageId" element={<PageLabPage />} />
        <Route path="matrix/bootstrap-capture" element={<BootstrapCapturePage />} />
        <Route path="matrix/hero-stock" element={<HeroStockReviewPage />} />
        <Route path="matrix/tiers" element={<TierMatrixPage />} />
        <Route path="matrix/parity" element={<BatchParityPage />} />
        <Route path="matrix/coverage" element={<CoveragePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
